import { useTranslation } from 'react-i18next';
import { Result, Button } from 'antd';
import { useMunicipalityFromHost } from '@/hooks';

interface LogoutScreenProps {
  onNavigateToLogin: () => void;
}

const LogoutScreen = ({ onNavigateToLogin }: LogoutScreenProps) => {
  const { t } = useTranslation('auth');
  const fromHost = useMunicipalityFromHost();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 to-blue-50 flex flex-col items-center justify-center p-6">
      {fromHost.name && (
        <p className="text-xs text-gray-500 mb-2">{fromHost.name}</p>
      )}
      <Result
        icon={<span className="text-5xl">👋</span>}
        title={t('loggedOut')}
        subTitle={t('logoutMessage')}
        extra={
          <Button type="primary" size="large" onClick={onNavigateToLogin} block className="max-w-md">
            {t('goToLogin')}
          </Button>
        }
      />
    </div>
  );
};

export default LogoutScreen;
